import {baseEnvironment} from "./environment.base";

export const environment = {
  ...baseEnvironment,
  production: false,
  apiHost: 'http://localhost:4200',
  ws: 'ws://domain/websocket',
  onLoad: 'check-sso',
  ismetLink: 'https://www.test.i-smet.kz',
  partnerLink: 'https://partner.i-smet.kz'
};
